var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "breadcrumb" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "" } },
            [
              _c("el-breadcrumb-item", [
                _c("div", { staticClass: "div1" }, [_vm._v("订单管理")]),
              ]),
              _c("el-breadcrumb-item", [
                _c("div", { staticClass: "div2", on: { click: _vm.toOrder } }, [
                  _vm._v("异常详情"),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "basic" }, [
        _c("p", { staticClass: "header" }, [_vm._v("订单信息")]),
        _c("ul", { staticClass: "ul" }, [
          _c("li", [
            _vm.queryType.fixDetail == 2 ||
            (_vm.queryType.exType == 0 &&
              _vm.queryType.fixDetail == 1 &&
              !_vm.tableData.parcelNumber) ||
            _vm.tableData.parcelNumber == 1
              ? _c("p", [
                  _vm._v(" 原订单编号：" + _vm._s(_vm.tableData.orderId) + " "),
                ])
              : _vm._e(),
            _c("p", [
              _vm._v("订单编号：" + _vm._s(_vm.tableData.returnOrderId)),
            ]),
            _vm.queryType.orderType == 1 && _vm.queryType.exType == 1
              ? _c("p", [_vm._v(" 订单状态： 被退货中 ")])
              : _vm._e(),
            Number(_vm.queryType.orderType) === 0 &&
            Number(_vm.queryType.exType) === 1
              ? _c("p", [_vm._v(" 订单状态： 拒收中 ")])
              : _vm._e(),
            _vm.queryType.exType == 0 &&
            (_vm.queryType.orderType == 2 ||
              _vm.queryType.orderType == 1 ||
              !_vm.queryType.orderType)
              ? _c("p", [
                  _vm._v(
                    " 订单状态： " +
                      _vm._s(
                        _vm.tableData.returnStatusName
                          ? _vm.tableData.returnStatusName
                          : "退货中"
                      ) +
                      " "
                  ),
                ])
              : _vm._e(),
            _c("p", [_vm._v("时 间 ：" + _vm._s(_vm.tableData.applyTime))]),
            _c("p", [_vm._v("客服：" + _vm._s(_vm.tableData.applyName))]),
          ]),
          _c("li", [
            _c("span", [_vm._v("客户信息 ：")]),
            _c("span", [_vm._v(_vm._s(_vm.tableData.customerName))]),
            _c("span", [_vm._v(_vm._s(_vm.tableData.customerPhone))]),
            _c("span", [_vm._v(_vm._s(_vm.tableData.detailedAddress))]),
          ]),
          _c("li", [
            _c("span", [_vm._v("收货信息 ：")]),
            _c("span", [_vm._v(_vm._s(_vm.tableData.addressName))]),
            _c("span", [_vm._v(_vm._s(_vm.tableData.addressPhone))]),
            _c("span", [_vm._v(_vm._s(_vm.tableData.address))]),
          ]),
          _c("li", [
            _c("span", [_vm._v("备注 ：")]),
            _vm.tableData.comment
              ? _c("span", [_vm._v(_vm._s(_vm.tableData.comment))])
              : _c("span", [_vm._v("无")]),
          ]),
          _vm.queryType.fixDetail == 2 ||
          (_vm.queryType.exType == 0 &&
            _vm.queryType.fixDetail == 1 &&
            !_vm.tableData.parcelNumber) ||
          _vm.tableData.parcelNumber == 1
            ? _c("li", [
                _c("span", [_vm._v("包裹单号 ：")]),
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.tableData.logisticsCompany) +
                      " " +
                      _vm._s(_vm.tableData.parcelNumber)
                  ),
                ]),
              ])
            : _vm._e(),
          _vm.queryType.exType == 0 &&
          _vm.queryType.fixDetail == 1 &&
          _vm.tableData.parcelNumber &&
          _vm.tableData.parcelNumber != 1
            ? _c("div", { staticClass: "contentTemp" }, [
                _c("div", { staticClass: "fontTemp" }, [
                  _vm._m(0),
                  _c(
                    "div",
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: "快递公司",
                            filterable: "",
                            clearable: "",
                            size: "mini",
                          },
                          model: {
                            value: _vm.logisticsCompany,
                            callback: function ($$v) {
                              _vm.logisticsCompany = $$v
                            },
                            expression: "logisticsCompany",
                          },
                        },
                        _vm._l(_vm.companys, function (itemsS) {
                          return _c("el-option", {
                            key: itemsS.dictName,
                            attrs: {
                              label: itemsS.dictName,
                              value: itemsS.dictName,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    [
                      _c("el-input", {
                        attrs: {
                          size: "mini",
                          type: "text",
                          placeholder: "请输入包裹物流单号",
                        },
                        model: {
                          value: _vm.logistCode,
                          callback: function ($$v) {
                            _vm.logistCode = $$v
                          },
                          expression: "logistCode",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ])
            : _vm._e(),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "goods" },
        [
          _c("p", { staticClass: "header" }, [_vm._v("商品详情")]),
          _c("span", [_vm._v(" 商品 ")]),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData.orderReturnCommodityList,
                align: "center",
              },
            },
            [
              _c("el-table-column", {
                attrs: { label: "品牌", prop: "brand" },
              }),
              _c("el-table-column", {
                attrs: { label: "商品名称", prop: "commodityName" },
              }),
              _c("el-table-column", {
                attrs: { label: "原订单数", prop: "originalNumber" },
              }),
              _vm.queryType.exType == 0 &&
              (_vm.queryType.orderType == 2 ||
                _vm.queryType.orderType == 1 ||
                !_vm.queryType.orderType) &&
              _vm.queryType.fixDetail == 2
                ? _c("el-table-column", {
                    attrs: { label: "退货数量", prop: "number" },
                  })
                : _vm._e(),
              _vm.queryType.exType == 0 && _vm.queryType.fixDetail == 1
                ? _c("el-table-column", {
                    attrs: { label: "可退货数量", prop: "waitNumber" },
                  })
                : _vm._e(),
              _vm.queryType.exType == 0 &&
              _vm.queryType.fixDetail == 1 &&
              _vm.queryType.type == "A"
                ? _c("el-table-column", {
                    attrs: { label: "退货数量", width: "150" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                { staticClass: "numer" },
                                [
                                  _c("el-input-number", {
                                    attrs: {
                                      min: 0,
                                      size: "mini",
                                      max: scope.row.waitNumber,
                                      label: "描述文字",
                                    },
                                    model: {
                                      value: scope.row.numberC,
                                      callback: function ($$v) {
                                        _vm.$set(scope.row, "numberC", $$v)
                                      },
                                      expression: "scope.row.numberC",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      382235652
                    ),
                  })
                : _vm._e(),
              (_vm.queryType.exType == 1 &&
                (_vm.queryType.orderType == 0 ||
                  _vm.queryType.orderType == 1)) ||
              (_vm.queryType.exType == 0 && _vm.queryType.fixDetail == 2)
                ? _c("el-table-column", {
                    attrs: { label: "仓库收货", width: "150" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("div", { staticClass: "numer" }, [
                                _c("span", [
                                  _vm._v(
                                    "已收：" + _vm._s(scope.row.receivedNo)
                                  ),
                                ]),
                                _c("span", [
                                  _vm._v(
                                    "破损：" + _vm._s(scope.row.destroyNo)
                                  ),
                                ]),
                                _c("span", [
                                  _vm._v("漏件：" + _vm._s(scope.row.brokenNo)),
                                ]),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2136996153
                    ),
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: { label: "单价", prop: "price" },
              }),
              _c("el-table-column", {
                attrs: { label: "规格", prop: "specificationName" },
              }),
              this.queryType.exType == 1 && this.queryType.orderType == 1
                ? _c("el-table-column", {
                    attrs: { label: "被退货小计", prop: "total" },
                  })
                : _vm._e(),
              this.queryType.exType == 1 && this.queryType.orderType == 0
                ? _c("el-table-column", {
                    attrs: { label: "拒收小计", prop: "total" },
                  })
                : _vm._e(),
              this.queryType.exType == 0
                ? _c("el-table-column", {
                    attrs: { label: "退货小计", prop: "total" },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c("span", [_vm._v(" 赠品 ")]),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData.orderReturnComplimentaryList,
                align: "center",
              },
            },
            [
              _c("el-table-column", {
                attrs: { label: "品牌", prop: "brand" },
              }),
              _c("el-table-column", {
                attrs: { label: "商品名称", prop: "complimentaryName" },
              }),
              _c("el-table-column", {
                attrs: { label: "原订单数", prop: "originalNumber" },
              }),
              _vm.queryType.exType == 0 &&
              (_vm.queryType.orderType == 2 ||
                _vm.queryType.orderType == 1 ||
                !_vm.queryType.orderType) &&
              _vm.queryType.fixDetail == 2
                ? _c("el-table-column", {
                    attrs: { label: "退货数量", prop: "number" },
                  })
                : _vm._e(),
              _vm.queryType.exType == 0 && _vm.queryType.fixDetail == 1
                ? _c("el-table-column", {
                    attrs: { label: "可退货数量", prop: "waitNumber" },
                  })
                : _vm._e(),
              _vm.queryType.exType == 0 && _vm.queryType.fixDetail == 1
                ? _c("el-table-column", {
                    attrs: { label: "退货数量", width: "150" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                { staticClass: "numer" },
                                [
                                  _c("el-input-number", {
                                    attrs: {
                                      min: 0,
                                      size: "mini",
                                      max: scope.row.waitNumber,
                                      label: "描述文字",
                                    },
                                    model: {
                                      value: scope.row.numberC,
                                      callback: function ($$v) {
                                        _vm.$set(scope.row, "numberC", $$v)
                                      },
                                      expression: "scope.row.numberC",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      382235652
                    ),
                  })
                : _vm._e(),
              (_vm.queryType.exType == 1 &&
                (_vm.queryType.orderType == 0 ||
                  _vm.queryType.orderType == 1)) ||
              (_vm.queryType.exType == 0 && _vm.queryType.fixDetail == 2)
                ? _c("el-table-column", {
                    attrs: { label: "仓库收货", width: "200" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("div", { staticClass: "numer" }, [
                                _c("span", [
                                  _vm._v(
                                    "已收：" + _vm._s(scope.row.receivedNo)
                                  ),
                                ]),
                                _c("span", [
                                  _vm._v(
                                    "破损：" + _vm._s(scope.row.destroyNo)
                                  ),
                                ]),
                                _c("span", [
                                  _vm._v("漏件：" + _vm._s(scope.row.brokenNo)),
                                ]),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2136996153
                    ),
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: { label: "单价", prop: "price" },
              }),
              _c("el-table-column", {
                attrs: { label: "规格", prop: "specificationName" },
              }),
              this.queryType.exType == 1 && this.queryType.orderType == 1
                ? _c("el-table-column", {
                    attrs: { label: "被退货小计", prop: "total" },
                  })
                : _vm._e(),
              this.queryType.exType == 1 && this.queryType.orderType == 0
                ? _c("el-table-column", {
                    attrs: { label: "拒收小计", prop: "total" },
                  })
                : _vm._e(),
              this.queryType.exType == 0
                ? _c("el-table-column", {
                    attrs: { label: "退货小计", prop: "total" },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "total" }, [
        _c("div", { staticClass: "before" }, [
          _c("p", [_vm._v("原单总计")]),
          _c("p", [_vm._v("共 " + _vm._s(_vm.tableData.orderNumber) + " 件")]),
          _c("p", [_vm._v("运费：￥" + _vm._s(_vm.tableData.orderCharge))]),
          _c("p", [_vm._v("赠品总价： ￥0")]),
          _c("p", [_vm._v("商品总价：￥" + _vm._s(_vm.tableData.orderTotal))]),
          _c("p", [_vm._v("应收金额：￥" + _vm._s(_vm.tableData.orderMoney))]),
          _c("p", [
            _vm._v("已收金额：￥" + _vm._s(_vm.tableData.orderReceivedMoney)),
          ]),
          _c("p", [
            _vm._v(
              "代收金额：￥" + _vm._s(_vm.tableData.orderAwaitIncomeMoney)
            ),
          ]),
        ]),
        (_vm.queryType.exType == 0 &&
          (_vm.queryType.orderType == 2 || _vm.queryType.orderType == 1)) ||
        !_vm.queryType.orderType
          ? _c("div", { staticClass: "back" }, [
              _c("p", [_vm._v("退货总计")]),
              _c("p", [_vm._v("共 " + _vm._s(_vm.totalCout(1)) + " 件")]),
            ])
          : _vm._e(),
        _vm.queryType.exType != 0
          ? _c("div", { staticClass: "totalAll" }, [
              _c("span", [_vm._v("仓库收货总计")]),
              _c("span", [_vm._v("已收 " + _vm._s(_vm.test(0)) + " 件")]),
              _c("span", [_vm._v("破损 " + _vm._s(_vm.test(1)) + " 件")]),
              _c("span", [_vm._v("漏件 " + _vm._s(_vm.test(2)) + " 件")]),
              _c("span", [_vm._v("已收货总价 ￥ " + _vm._s(_vm.totalCout(2)))]),
            ])
          : _vm._e(),
        _c("div", { staticClass: "deal" }, [
          _c("div", { staticStyle: { width: "200px", "text-align": "left" } }, [
            _c("p", [
              _vm._v(
                "已收金额： ￥" + _vm._s(_vm.tableData.orderReceivedMoney)
              ),
            ]),
            _c("div"),
            _vm.queryType.fixDetail == 2
              ? _c("div", { staticStyle: { "text-align": "left" } }, [
                  _c("p", [
                    _c("span"),
                    _vm._v("实退金额：￥" + _vm._s(_vm.tableData.returnMoney)),
                  ]),
                  _c("p", [
                    _c("span"),
                    _vm._v(
                      "已退总金额：￥" +
                        _vm._s(
                          _vm.tableData.orderResponse.orderUser.returnMoneyAll
                        )
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm.queryType.fixDetail == 1
              ? _c("div", { staticStyle: { "text-align": "left" } }, [
                  _c("p", [_vm._v("实退金额")]),
                  _c(
                    "p",
                    [
                      (_vm.queryType.exType == 1 &&
                        _vm.queryType.orderType == 1 &&
                        _vm.queryType.fixDetail == 1) ||
                      (_vm.queryType.exType == 0 &&
                        _vm.queryType.fixDetail == 1)
                        ? _c("el-input-number", {
                            staticStyle: { width: "100px" },
                            attrs: {
                              min: 0,
                              max: _vm.totalCout(2),
                              controls: false,
                              value: _vm.tableData.returnMoney,
                            },
                            on: { input: _vm.inp },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
          ]),
        ]),
      ]),
      _vm.queryType.fixDetail == 1
        ? _c("div", { staticClass: "notes" }, [
            _c("p", { staticClass: "header" }, [_vm._v("备注")]),
            _c(
              "div",
              [
                _c("el-input", {
                  attrs: {
                    type: "textarea",
                    placeholder: "请输入需要备注信息.....",
                  },
                  model: {
                    value: _vm.textarea,
                    callback: function ($$v) {
                      _vm.textarea = $$v
                    },
                    expression: "textarea",
                  },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm.parArray.indexOf("submitJl") == -1 &&
      _vm.tableData.returnStatus == 1 &&
      _vm.queryType.fixDetail == 1
        ? _c("div", { staticClass: "submit" }, [
            (((_vm.queryType.orderType == 2 || _vm.queryType.orderType == 1) &&
              _vm.queryType.exType == 0) ||
              !_vm.queryType.orderType) &&
            _vm.parArray.indexOf("byReturnCode") == -1
              ? _c("p", { on: { click: _vm.submintEvent } }, [
                  _vm._v(" 提交退货 "),
                ])
              : _vm._e(),
            Number(_vm.queryType.orderType) === 1 &&
            Number(_vm.queryType.exType) === 1 &&
            _vm.parArray.indexOf("byReturnCode") == -1
              ? _c("p", { on: { click: _vm.submintEvent } }, [
                  _vm._v(" 提交被退货 "),
                ])
              : _vm._e(),
            Number(_vm.queryType.orderType) === 0 &&
            Number(_vm.queryType.exType) === 1 &&
            _vm.parArray.indexOf("byReturnCode") == -1
              ? _c("p", { on: { click: _vm.submintEvent } }, [
                  _vm._v(" 提交拒收 "),
                ])
              : _vm._e(),
            _vm.queryType.exType != 0 &&
            _vm.parArray.indexOf("byReturnCode") != -1
              ? _c("p", { on: { click: _vm.submintEvent } }, [_vm._v(" 关闭 ")])
              : _vm._e(),
          ])
        : _vm._e(),
      (_vm.parArray.indexOf("submitJl") != -1 &&
        _vm.tableData.returnStatus == 1 &&
        _vm.queryType.fixDetail == 1) ||
      (_vm.parArray.indexOf("byReturnCode") != -1 &&
        _vm.queryType.exType == 0 &&
        _vm.queryType.fixDetail == 1)
        ? _c("div", { staticClass: "submit" }, [
            _c(
              "p",
              {
                staticStyle: {
                  background: "#fff",
                  color: "#4168E7",
                  border: "1px solid #4168E7",
                  "margin-right": "20px",
                  height: "28px",
                },
                on: {
                  click: function ($event) {
                    ;(_vm.dialogVisible = true), (_vm.rejectType = 0)
                  },
                },
              },
              [_vm._v(" 驳回 ")]
            ),
            _c(
              "p",
              {
                on: {
                  click: function ($event) {
                    ;(_vm.dialogVisible = true), (_vm.rejectType = 1)
                  },
                },
              },
              [_vm._v(" 批准 ")]
            ),
          ])
        : _vm._e(),
      _c(
        "div",
        { staticClass: "oldOrder" },
        [
          _c("div", { staticClass: "title" }, [_vm._v(" 关联原订单号 ")]),
          _c(
            "el-table",
            { staticStyle: { width: "100%" }, attrs: { data: _vm.oldOrder } },
            [
              _c("el-table-column", {
                attrs: { type: "expand" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(" 商品 "),
                        _c(
                          "el-table",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              border: "",
                              data: _vm.tableData.orderResponse
                                .orderCommodityList,
                            },
                          },
                          [
                            _c("el-table-column", {
                              attrs: { label: "图片" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("el-image", {
                                          staticStyle: {
                                            width: "100px",
                                            height: "100px",
                                          },
                                          attrs: {
                                            src: _vm.img(scope.row.image),
                                            fit: "cover",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: { prop: "brandName", label: "品牌" },
                            }),
                            _c("el-table-column", {
                              attrs: { prop: "name", label: "商品名称" },
                            }),
                            _c("el-table-column", {
                              attrs: { prop: "number", label: "商品数量" },
                            }),
                            _c("el-table-column", {
                              attrs: { prop: "price", label: "单价" },
                            }),
                            _c("el-table-column", {
                              attrs: {
                                label: "规格",
                                prop: "specificationName",
                              },
                            }),
                            _c("el-table-column", {
                              attrs: { prop: "total", label: "商品小计" },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" 赠品 "),
                        _c(
                          "el-table",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              border: "",
                              data: _vm.tableData.orderResponse
                                .orderComplimentaryList,
                            },
                          },
                          [
                            _c("el-table-column", {
                              attrs: { label: "图片" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("el-image", {
                                          staticStyle: {
                                            width: "100px",
                                            height: "100px",
                                          },
                                          attrs: {
                                            src: _vm.img(scope.row.image),
                                            fit: "cover",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: { prop: "brandName", label: "品牌" },
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "complimentaryName",
                                label: "商品名称",
                              },
                            }),
                            _c("el-table-column", {
                              attrs: { prop: "number", label: "商品数量" },
                            }),
                            _c("el-table-column", {
                              attrs: { prop: "price", label: "单价" },
                            }),
                            _c("el-table-column", {
                              attrs: {
                                label: "规格",
                                prop: "specificationName",
                              },
                            }),
                            _c("el-table-column", {
                              attrs: { prop: "total", label: "商品小计" },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "orderId", label: "订单编号" },
              }),
              _c("el-table-column", {
                attrs: { prop: "customerUserName", label: "客户" },
              }),
              _c("el-table-column", {
                attrs: { prop: "createdName", label: "客服" },
              }),
              _c("el-table-column", {
                attrs: { prop: "orderType", label: "订单状态" },
              }),
              _c("el-table-column", {
                attrs: { prop: "receivedMoney", label: "金额" },
              }),
              _c("el-table-column", {
                attrs: { label: "包裹单号" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(scope.row.logisticsOrder.parcelNumber) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "收货信息" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.addressName))]),
                        _c("span", [
                          _vm._v(" " + _vm._s(scope.row.addressPhone) + " "),
                        ]),
                        _c("span", [_vm._v(" " + _vm._s(scope.row.address))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "createdTime", label: "下单时间" },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "批准驳回操作",
            "append-to-body": "",
            visible: _vm.dialogVisible,
            width: "30%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("el-input", {
            attrs: {
              type: "textarea",
              autosize: "",
              placeholder: "请输入内容",
            },
            model: {
              value: _vm.textarea1,
              callback: function ($$v) {
                _vm.textarea1 = $$v
              },
              expression: "textarea1",
            },
          }),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.reject } },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticStyle: { height: "60px" } }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [_c("span", [_vm._v("*")]), _vm._v("退货单号:")])
  },
]
render._withStripped = true

export { render, staticRenderFns }